import TutorScheduleWeeklyLesson from './TutorScheduleWeeklyLesson';

export default TutorScheduleWeeklyLesson;
